import { render, staticRenderFns } from "./businessUsage.vue?vue&type=template&id=56193e87&scoped=true&"
import script from "./businessUsage.vue?vue&type=script&lang=js&"
export * from "./businessUsage.vue?vue&type=script&lang=js&"
import style0 from "./businessUsage.vue?vue&type=style&index=0&id=56193e87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56193e87",
  null
  
)

export default component.exports